export const PERMISSIONS = {
  SHOW: 1,
  ADD: 2,
  EDIT: 3,
  DELETE_SOFT: 4,
  DELETE_PERM: 5,
  PENDING_APPROVE: 6,
  APPROVE: 7,
  CAN_PUBLISH: 8,
};
export const getPermissionById = (id) => {
  let permissionKeys = Object.keys(PERMISSIONS);
  let permission = "";
  permissionKeys.forEach((key) => {
    if (PERMISSIONS[key] === id) {
      permission = key;
      return;
    }
  });
  return permission;
};
// Departments	[ 1, 2, 3, 4, 5, 6, 7 ]
// Users	[ 1, 2, 3, 4, 5, 6, 7 ]
// Roles	[ 1, 2, 3, 4, 5, 6, 7 ]
// Permissions	[ 1, 2, 3, 4, 5, 6, 7 ]
// Menus	[ 1, 2, 3, 4, 5, 6, 7 ]
// Settings	[ 1, 2, 3, 4, 5, 6, 7 ]
// Languages	[ 1, 2, 3, 4, 5, 6, 7 ]
// News categories	[ 1, 2, 3, 4, 5, 6, 7 ]
// News tags	[ 1, 2, 3, 4, 5, 6, 7 ]
// News	[ 1, 2, 3, 4, 5, 6, 7 ]
// Pages	[ 1, 2, 3, 4, 5, 6, 7 ]
// Forums	[ 1, 2, 3, 4, 5, 6, 7 ]
// Media Library	[ 1, 2, 3, 4, 5, 6, 7 ]
// Gallery library	[ 1, 2, 3, 4, 5, 6, 7 ]
// Country	[ 1, 2, 3, 4, 5, 6, 7 ]
// Regional Offices	[ 1, 2, 3, 4, 5, 6, 7 ]
// Event Types	[ 1, 2, 3, 4, 5, 6, 7 ]
// Events	[ 1, 2, 3, 4, 5, 6, 7 ]
// Training Programs	[ 1, 2, 3, 4, 5, 6, 7 ]
// Training Program Applications	[ 1, 2, 3, 4, 5, 6, 7 ]
// Journalisms	[ 1, 2, 3, 4, 5, 6, 7 ]
// Media Library Category	[ 1, 2, 3, 4, 5, 6, 7 ]
// Organization Category	[ 1, 2, 3, 4, 5, 6, 7 ]
// Organization Hierarchy	[ 1, 2, 3, 4, 5, 6, 7 ]
// Journal Category	[ 1, 2, 3, 4, 5, 6, 7 ]
// Site Selection	[ 1, 2, 3, 4, 5, 6, 7, 8 ]
// Publication News	[ 1, 2, 3, 4, 5, 6, 7, 8 ]
// Happening Now	[ 1, 2, 3, 4, 5, 6, 7, 8 ]
// Filters [ 1, 2, 3, 4, 5, 6, 7, 8 ]
// Indicators [ 1, 2, 3, 4, 5, 6, 7, 8 ]
// Selected Indicator [ 1, 2, 3, 4, 5, 6, 7, 8 ]
